import SwitchingCategoriesIcon from "../../../assets/Switching/switchingCategoriesIcon.svg";
import type { ProductGroup } from "../../../types";

export const enterprise: ProductGroup = {
  id: "enterprise",
  title: "productGroup.enterprise.title",
  icon: {
    src: SwitchingCategoriesIcon,
    width: 64,
    height: 40,
  },
};
